import { render, staticRenderFns } from "./sparePartClassify.vue?vue&type=template&id=c2895fe0&scoped=true"
import script from "./sparePartClassify.vue?vue&type=script&lang=js"
export * from "./sparePartClassify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2895fe0",
  null
  
)

export default component.exports